import { forwardRef } from 'react';
import { Breadcrumb as AntdBreadcrumb } from 'antd';
import { AltArrowRightBoldIcon } from '@solar-icons/react';
import './Breadcrumb.module.css';

/**
 * @param {Object} props
 * @param {Array<Object>} props.items - Same shape as antd's own `items`
 * @param {boolean} [props.showTrailingChevron=true] - Renders a chevron after the last item,
 *   pointing on toward whatever follows the breadcrumb (e.g. a page title) rather than treating
 *   the last item as a dead end. Implemented as an invisible extra item appended after `items` —
 *   antd only renders a crumb's separator when it isn't the last item, and an empty title
 *   renders no `li` of its own, so the real last item gets a trailing chevron with nothing
 *   visibly following it.
 */
// separator is destructured out and discarded rather than spread, so it's hard-locked — a
// consumer's separator={...} prop silently does nothing, same treatment as Dialog's mask/closeIcon.
const Breadcrumb = forwardRef(({ separator, items, showTrailingChevron = true, ...props }, ref) => (
    <AntdBreadcrumb
        ref={ref}
        separator={<AltArrowRightBoldIcon size={14} color="var(--color-text-tertiary)" />}
        items={showTrailingChevron && items ? [...items, { title: '' }] : items}
        {...props}
    />
));
Breadcrumb.displayName = 'Breadcrumb';

export default Breadcrumb;
